import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Div } from 'glamorous';
import AdminSidebar from './AdminSidebar';
import {
  ADMIN_DRAWER_COLLAPSED_WIDTH,
  ADMIN_DRAWER_WIDTH,
  ADMIN_SIDEBAR_COLLAPSED_STORAGE_KEY,
  getAdminDrawerWidth,
} from './admin/constants';

function readSidebarCollapsed() {
  try {
    return window.localStorage.getItem(ADMIN_SIDEBAR_COLLAPSED_STORAGE_KEY) === '1';
  } catch (err) {
    return false;
  }
}

function writeSidebarCollapsed(collapsed) {
  try {
    window.localStorage.setItem(ADMIN_SIDEBAR_COLLAPSED_STORAGE_KEY, collapsed ? '1' : '0');
  } catch (err) {
    // ignore quota / private mode
  }
}

const styles = (theme) => ({
  layout: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
  },
  /** Основная колонка: отступ слева = ширина fixed Drawer, иначе контент уезжает под сайдбар. */
  main: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    transition: theme.transitions.create('margin-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
});

class AdminLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarCollapsed: readSidebarCollapsed(),
    };
  }

  handleToggleSidebar = () => {
    this.setState((prev) => {
      const sidebarCollapsed = !prev.sidebarCollapsed;
      writeSidebarCollapsed(sidebarCollapsed);
      return { sidebarCollapsed };
    });
  };

  render() {
    const { classes, userRole, children } = this.props;
    const { sidebarCollapsed } = this.state;
    const drawerWidth = getAdminDrawerWidth(sidebarCollapsed);

    return (
      <Div className={classes.layout}>
        <AdminSidebar
          userRole={userRole}
          collapsed={sidebarCollapsed}
          onToggleCollapsed={this.handleToggleSidebar}
        />
        <Div
          className={classes.main}
          style={{ marginLeft: drawerWidth }}
        >
          {children}
        </Div>
      </Div>
    );
  }
}

AdminLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  userRole: PropTypes.oneOf(['administrator', 'moderator']).isRequired,
  children: PropTypes.node.isRequired,
};

export { ADMIN_DRAWER_WIDTH, ADMIN_DRAWER_COLLAPSED_WIDTH, getAdminDrawerWidth };
export default withStyles(styles)(AdminLayout);
